import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="loading-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-3 border-blue-900 border-t-transparent rounded-full animate-spin" />
          <p className="text-slate-500 font-manrope text-sm tracking-wide">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
